import { render, staticRenderFns } from "./ExamCenter.vue?vue&type=template&id=144e1409&scoped=true&"
import script from "./ExamCenter.vue?vue&type=script&lang=js&"
export * from "./ExamCenter.vue?vue&type=script&lang=js&"
import style0 from "./ExamCenter.vue?vue&type=style&index=0&id=144e1409&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144e1409",
  null
  
)

component.options.__file = "ExamCenter.vue"
export default component.exports